const confirmationProductTypes = new Set(['plan', 'subscription']);

function requiresFitConfirmation(cart) {
  return (
    cart?.cartItemsAttributes?.some((cartItem) => {
      const product = cartItem?.product;
      const productType = product?.productType?.toLowerCase();

      return (
        product?.isRetainer === true ||
        confirmationProductTypes.has(productType)
      );
    }) === true
  );
}

export default requiresFitConfirmation;
